// TODO: Swap this with color scheme
export const orange = "#FFCA28";
export const darkBlue = "#0758A4";
export const blue = "#40C4FF";
export const black = "#000000";
export const white = "#F0EFF4"
;